"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _breakpoints = require("../../../../helpers/breakpoints");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const percentage = value => `${100 * value}%`;

const getColumnStyleForSize = (size, colums, props) => {
  if (size === 'auto') {
    return (0, _styledComponents.css)`
            display: ${props.display ? props.display : 'block'};
            flex: 0 0 auto;
            width: auto;
            max-width: 100%;
        `;
  } else if (size === 'equal') {
    return (0, _styledComponents.css)`
            display: ${props.display ? props.display : 'block'};
            flex: 1;
            max-width: 100%;
        `;
  } else if (size === 'hide') {
    return (0, _styledComponents.css)`
            display: none;
        `;
  }

  return (0, _styledComponents.css)`
        display: ${props.display ? props.display : 'block'};
        flex: 0 0 ${percentage(size / colums)};
        max-width: ${percentage(size / colums)};
    `;
};

const getColumnStyleForOffset = (offset, colums) => (0, _styledComponents.css)`
    margin-left: ${percentage(offset / colums)};
`;

const getColumnStyleForPush = (push, colums) => (0, _styledComponents.css)`
    left: ${percentage(push / colums)};
`;

const getColumnStyleForPull = (pull, colums) => (0, _styledComponents.css)`
    right: ${percentage(pull / colums)};
`;

const getColumnStyleForOrder = order => (0, _styledComponents.css)`
    order: ${order};
`;

const hasSize = props => props.xxs || props.xs || props.sm || props.md || props.lg || props.xl;

const StyledCol = _styledComponents.default.div`
    box-sizing: border-box;
    display: block;
    position: relative;
    width: 100%;
    padding-right: ${props => `calc(${props.theme.gridGutterWidth} / 2)`};
    padding-left: ${props => `calc(${props.theme.gridGutterWidth} / 2)`};

    ${props => !hasSize(props) && (0, _styledComponents.css)`
        flex-basis: 0;
        flex-grow: 1;
    `}

    ${props => props.display !== undefined && (0, _styledComponents.css)`
        display: ${props => props.display};
    `}

    ${props => props.flex !== undefined && (0, _styledComponents.css)`
        flex: ${props => props.flex};
    `}

    ${props => props.alignItems !== undefined && (0, _styledComponents.css)`
        align-items: ${props => props.alignItems};
    `}

    ${props => props.col && getColumnStyleForSize(props.col, props.theme.gridColumns, props)}
    ${props => props.offset && getColumnStyleForOffset(props.offset, props.theme.gridColumns)}
    ${props => props.push && getColumnStyleForPush(props.push, props.theme.gridColumns)}
    ${props => props.pull && getColumnStyleForPull(props.pull, props.theme.gridColumns)}
    ${props => props.order && getColumnStyleForOrder(props.order)}
    
    ${_breakpoints.breakpointUp.xxs`
        ${props => props.xxs && getColumnStyleForSize(props.xxs, props.theme.gridColumns, props)}
        ${props => props.offset_xxs && getColumnStyleForOffset(props.offset_xxs, props.theme.gridColumns)}
        ${props => props.push_xss && getColumnStyleForPush(props.push_xss, props.theme.gridColumns)}
        ${props => props.pull_xss && getColumnStyleForPull(props.pull_xss, props.theme.gridColumns)}
        ${props => props.order_xxs && getColumnStyleForOrder(props.order_xxs)}
    `}

    ${_breakpoints.breakpointUp.xs`
        ${props => props.xs && getColumnStyleForSize(props.xs, props.theme.gridColumns, props)}
        ${props => props.offset_xs && getColumnStyleForOffset(props.offset_xs, props.theme.gridColumns)}
        ${props => props.push_xs && getColumnStyleForPush(props.push_xs, props.theme.gridColumns)}
        ${props => props.pull_xs && getColumnStyleForPull(props.pull_xs, props.theme.gridColumns)}
        ${props => props.order_xs && getColumnStyleForOrder(props.order_xs)}
    `}

    ${_breakpoints.breakpointUp.sm`
        ${props => props.sm && getColumnStyleForSize(props.sm, props.theme.gridColumns, props)}
        ${props => props.offset_sm && getColumnStyleForOffset(props.offset_sm, props.theme.gridColumns)}
        ${props => props.push_sm && getColumnStyleForPush(props.push_sm, props.theme.gridColumns)}
        ${props => props.pull_sm && getColumnStyleForPull(props.pull_sm, props.theme.gridColumns)}
        ${props => props.order_sm && getColumnStyleForOrder(props.order_sm)}
    `}

    ${_breakpoints.breakpointUp.md`
        ${props => props.md && getColumnStyleForSize(props.md, props.theme.gridColumns, props)}
        ${props => props.offset_md && getColumnStyleForOffset(props.offset_md, props.theme.gridColumns)}
        ${props => props.push_md && getColumnStyleForPush(props.push_md, props.theme.gridColumns)}
        ${props => props.pull_md && getColumnStyleForPull(props.pull_md, props.theme.gridColumns)}
        ${props => props.order_md && getColumnStyleForOrder(props.order_md)}
    `}

    ${_breakpoints.breakpointUp.lg`
        ${props => props.lg && getColumnStyleForSize(props.lg, props.theme.gridColumns, props)}
        ${props => props.offset_lg && getColumnStyleForOffset(props.offset_lg, props.theme.gridColumns)}
        ${props => props.push_lg && getColumnStyleForPush(props.push_lg, props.theme.gridColumns)}
        ${props => props.pull_lg && getColumnStyleForPull(props.pull_lg, props.theme.gridColumns)}
        ${props => props.order_lg && getColumnStyleForOrder(props.order_lg)}
    `}

    ${_breakpoints.breakpointUp.xl`
        ${props => props.xl && getColumnStyleForSize(props.xl, props.theme.gridColumns, props)}
        ${props => props.offset_xl && getColumnStyleForOffset(props.offset_xl, props.theme.gridColumns)}
        ${props => props.push_xl && getColumnStyleForPush(props.push_xl, props.theme.gridColumns)}
        ${props => props.pull_xl && getColumnStyleForPull(props.pull_xl, props.theme.gridColumns)}
        ${props => props.order_xl && getColumnStyleForOrder(props.order_xl)}
    `}
    
    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
var _default = StyledCol;
exports.default = _default;